import createAxios from './../../axiosHttps';

export const warehouseService = {
    getWarehouses,
    getWarehouseStock,
    getWarehouseById
};

const axiosInstance = createAxios();

function buildQueryUrl(basePath, query = {}) {
    const url = new URL(basePath, window.location.origin);
    const params = new URLSearchParams();

    // Agregar los parámetros a la URL
    Object.keys(query).forEach(key => {
        if (query[key] !== undefined && query[key] !== null) {
            params.append(key, query[key]);
        }
    });

    // Devolver la URL completa
    url.search = params.toString();
    return url.pathname + url.search;
}

async function getWarehouses(filters, pagination, customerId) {
    const query = {
        page: pagination ? pagination.currentPage - 1 : 0,
        limit: pagination ? pagination.rows : 20,
        search: filters?.search,
        sort: filters?.sort?.sort ? filters?.sort?.sort : '_id',
        order: filters?.sort?.order ? filters?.sort?.order : 'ascending'
    };

    const urlPath = buildQueryUrl(`/customer/${customerId}/warehouse`, query);
    return await axiosInstance.get(urlPath).catch(handleError);
}

async function getWarehouseStock(filters, pagination, customerId) {
    const query = {
        page: pagination ? pagination.currentPage - 1 : 0,
        limit: pagination ? pagination.rows : 20,
        search: filters?.search,
        sort: filters?.sort?.sort ? filters?.sort?.sort : '_id',
        order: filters?.sort?.order ? filters?.sort?.order : 'ascending'
    };

    const urlPath = buildQueryUrl(`/customer/${customerId}/warehouse-stock`, query);
    return await axiosInstance.get(urlPath).catch(handleError);
}

async function getWarehouseById(id, customerId) {
    const urlPath = buildQueryUrl(`/customer/${customerId}/warehouse/${id}`);
    return await axiosInstance.get(urlPath).catch(handleError);
}

function handleError(error) {
    console.error('API call failed:', error);
    throw axiosInstance;
}
